import React from 'react';
import moment from 'moment';

const PressNDate = ({press, date}) => {
    const today = moment().format('YYYY.MM.DD')
    const isToday = date.includes(today)

    const dateConverter = () => {
        if(isToday){
            return date.slice(-8)
        } else {
            return date.slice(2,10)
        }
    }

    return (
        <span>
            {press} · {dateConverter()}
        </span>
    );
};

export default PressNDate;